<template>
  <div class="viewport-vignette"></div>
  <HeaderView />
  <router-view/>
  <FooterView />
  <LineIcon />
</template>

<script>
import HeaderView from './components/HeaderView.vue'
import FooterView from './components/FooterView.vue'
import LineIcon from './components/LineIcon.vue'

export default {
  components: {
    HeaderView,
    FooterView,
    LineIcon
  }
}
</script>

<style>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    margin: 0;
    padding: 0;
    font-family: 'Noto Serif JP', 'Hiragino Mincho ProN', 'Yu Mincho', 'YuMincho', serif;
    background-color: #000000;
    color: #ffffff;
}

#app {
    margin: 0;
    padding: 0;
}

.viewport-vignette {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 1) 0%,
        rgba(0, 0, 0, 0) 15%,
        rgba(0, 0, 0, 0) 85%,
        rgba(0, 0, 0, 1) 100%
    );
    pointer-events: none;
    z-index: 999;
}
</style>
